import React, { useEffect, useState } from 'react';
import { Box, Grid, CardContent, Card, styled, Typography, FormLabel } from '@mui/material';
import CustomMaster from '../common/CustomMaster';
import { useLocation } from 'react-router-dom';
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from '../../services/CommonServices';
import { genericGet } from '../../services/apiServices';
import { GET_COMPANY, UPDATE_COMPANY_TEMPLATE } from '../../services/apiRoutes';
import { Formik, Form } from 'formik';
import axios from 'axios';
import MessageBox from '../common/CustomMessageBox';
import Template1 from '../../assets/images/Template1.png';
import Template2 from '../../assets/images/Template2.png';
import Template3 from '../../assets/images/Template3.png';
import Template4 from '../../assets/images/Template4.png';
import Coa1 from '../../assets/images/coa1.png';
import Coa2 from '../../assets/images/coa2.png';
import Coa3 from '../../assets/images/coa3.png';
import Pl1 from '../../assets/images/Pl1.png';
import Pl2 from '../../assets/images/Pl2.png';
import Pl3 from '../../assets/images/Pl3.png';
import { t } from '../../constants/translationHelper';


const Template = () => {
    const [getAllCompany, setGetAllCompany] = useState([]);
    const [permission, setPermissions] = useState({});
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });

    const location = useLocation();
    const currentPath = location.pathname;

    const templateData = [
        { id: 1, title: 'List', ImgPath: Template1 },
        { id: 2, title: 'Ganmtt', ImgPath: Template2 },
        { id: 3, title: 'Kanban', ImgPath: Template3 },
        { id: 4, title: 'Calendar', ImgPath: Template4 },
    ];
    const coatemplateData = [
        { id: 1, title: 'List', ImgPath: Coa1 },
        { id: 2, title: 'Ganmtt', ImgPath: Coa2 },
        { id: 3, title: 'Kanban', ImgPath: Coa3 },
        { id: 4, title: 'Calendar', ImgPath: Coa3 },
    ];
    const packingTemplateData = [
        { id: 1, title: 'List', ImgPath: Pl1 },
        { id: 2, title: 'Ganmtt', ImgPath: Pl2 },
        { id: 3, title: 'Kanban', ImgPath: Pl3 },
        { id: 4, title: 'Calendar', ImgPath: Pl3 },
    ];

    const getCompanyList = async () => {
        try {
            const response = await genericGet({ url: GET_COMPANY });
            const CompanyData = response.data.companies;
            if (CompanyData) {
                setGetAllCompany(CompanyData);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const rolePermissions = JSON.parse(sessionStorage.getItem('userData')) || [];
        setPermissions({
            edit: hasEditPermission(currentPath, rolePermissions?.permissions),
            delete: hasDeletePermission(currentPath, rolePermissions?.permissions),
            create: hasCreatePermission(currentPath, rolePermissions?.permissions),
            view: hasViewPermission(currentPath, rolePermissions?.permissions),
        });
    }, []);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            const defaultCompany = getAllCompany.find(company => company.isDefault);
            const companyId = defaultCompany?.companyId;

            if (!companyId) {
                console.error("No default company found.");
                return;
            }

            const payload = {
                templateId: values.templateId,
                purchaseTemplateId: values.purchaseTemplateId,
                packingListTemplate: values.packingListTemplate,
                coaTemplate: values.coaTemplate,

            };

            const response = await axios.put(UPDATE_COMPANY_TEMPLATE(companyId), payload, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: response.message || "Template updated successfully",
                    type: "success",
                });
                getCompanyList();
            } else {
                console.error("Failed to update template");
            }
        } catch (error) {
            console.error("Error updating template:", error);
        } finally {
            setSubmitting(false);
        }
    };

    const defaultTemplateId = getAllCompany.find(company => company.isDefault)?.templateId;
    const defaultPurchaseTemplateId = getAllCompany.find(company => company.isDefault)?.purchaseTemplateId;
    const defaultPackingListTemplate = getAllCompany.find(company => company.isDefault)?.packingListTemplate;
    const defaultCoaTemplate = getAllCompany.find(company => company.isDefault)?.coaTemplate;


    const CustomCard = styled(Card)(({ theme }) => ({
        // minHeight: '350px',
        // maxHeight: '350px',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: theme.shadows[1],
        },
    }));

    const CardBody = styled(CardContent)(({ theme }) => ({
        padding: theme.spacing(0),
    }));

    const Heading = styled(Typography)(({ theme }) => ({
        fontWeight: 600,
    }));

    const mainContent = (
        <Box sx={{ mx: 'auto', mt: 2, ml: 1 }}>
            <Formik
                enableReinitialize
                initialValues={{
                    templateId: parseInt(defaultTemplateId) || '',
                    purchaseTemplateId: parseInt(defaultPurchaseTemplateId) || '',
                    packingListTemplate: parseInt(defaultPackingListTemplate) || '',
                    coaTemplate: parseInt(defaultCoaTemplate) || '',
                }}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, setFieldValue, values, submitForm }) => (
                    <Form>
                        <div >
                            <Box sx={{ display: "flex", alignItems: "baseline" }}>
                                <FormLabel style={fieldLabelstyle}> {t("Export shipment Template")} </FormLabel>
                                <Typography sx={tagLineStyle}>SO, PI, SC, CI,</Typography>
                            </Box>
                            <Grid container spacing={2}>
                                {templateData.map((card, index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                        <CustomCard
                                            variant="outlined"
                                            onClick={() => {
                                                setFieldValue('templateId', card.id);
                                                submitForm();
                                            }}
                                            sx={{
                                                borderColor:
                                                    values.templateId === card.id ? 'primary.main' : 'grey.300',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <CardBody sx={{ textAlign: 'center' }}>
                                                <Box sx={{ m: 1 }}>
                                                    <img
                                                        src={card.ImgPath}
                                                        alt={card.title}
                                                        style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                    />
                                                </Box>
                                            </CardBody>

                                        </CustomCard>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                        <div >
                            <Box sx={{ display: "flex", alignItems: "baseline", mt: "10px" }}>
                                <FormLabel style={fieldLabelstyle}> {t("Import shipment Template")} </FormLabel>
                                <Typography sx={tagLineStyle}>PO,</Typography>
                            </Box>
                            <Grid container spacing={2}>
                                {templateData.map((card, index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                        <CustomCard
                                            variant="outlined"
                                            onClick={() => {
                                                setFieldValue('purchaseTemplateId', card.id);
                                                submitForm();
                                            }}
                                            sx={{
                                                borderColor:
                                                    values.purchaseTemplateId === card.id ? 'primary.main' : 'grey.300',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <CardBody sx={{ textAlign: 'center' }}>
                                                <Box sx={{ m: 1 }}>
                                                    <img
                                                        src={card.ImgPath}
                                                        alt={card.title}
                                                        style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                    />
                                                </Box>
                                            </CardBody>
                                        </CustomCard>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                        <div >
                            <Box sx={{ display: "flex", alignItems: "baseline", mt: "10px" }}>
                                <FormLabel style={fieldLabelstyle}> {t("Packing List Template")} </FormLabel>
                            </Box>
                            <Grid container spacing={2}>
                                {packingTemplateData.map((card, index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                        <CustomCard
                                            variant="outlined"
                                            onClick={() => {
                                                setFieldValue('packingListTemplate', card.id);
                                                submitForm();
                                            }}
                                            sx={{
                                                borderColor:
                                                    values.packingListTemplate === card.id ? 'primary.main' : 'grey.300',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <CardBody sx={{ textAlign: 'center' }}>
                                                <Box sx={{ m: 1 }}>
                                                    <img
                                                        src={card.ImgPath}
                                                        alt={card.title}
                                                        style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                    />
                                                </Box>
                                            </CardBody>
                                        </CustomCard>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                        <div >
                            <Box sx={{ display: "flex", alignItems: "baseline", mt: "10px" }}>
                                <FormLabel style={fieldLabelstyle}> {t("COA Template")} </FormLabel>
                            </Box>
                            <Grid container spacing={2}>
                                {coatemplateData.map((card, index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                        <CustomCard
                                            variant="outlined"
                                            onClick={() => {
                                                setFieldValue('coaTemplate', card.id);
                                                submitForm();
                                            }}
                                            sx={{
                                                borderColor:
                                                    values.coaTemplate === card.id ? 'primary.main' : 'grey.300',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <CardBody sx={{ textAlign: 'center' }}>
                                                <Box sx={{ m: 1 }}>
                                                    <img
                                                        src={card.ImgPath}
                                                        alt={card.title}
                                                        style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                    />
                                                </Box>
                                            </CardBody>
                                        </CustomCard>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </Form>
                )}
            </Formik>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
        </Box>
    );

    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };

    return (
        <>
            <CustomMaster
                defaultView="template"
                mainContent={getMainContent(mainContent, permission)}
            />
            {!permission?.view && <AccessDenied />}
        </>
    );
};

export default Template;

const fieldLabelstyle = {
    color: "#212529",
    fontWeight: "600",
    fontSize: "14px",
    paddingBottom: "10px",
    textTransform: "capitalize"
};

const tagLineStyle = {
    fontSize: "10px",
    color: "#666",
    paddingLeft: "2px"
};
